<template>
  <path
    d="M29.403 26.536c-.11.16-.247.3-.402.414v.799c0 .568-.448 1.029-1 1.03-.553 0-1.002-.461-1.002-1.03v-.799c-.775-.568-.955-1.675-.402-2.471.553-.797 1.629-.982 2.404-.414.775.569.955 1.675.402 2.471zm-2.937-6.272c0-.871.687-1.578 1.534-1.58.847.002 1.534.709 1.534 1.58v1.238h-3.068v-1.238zm5.19 1.238h-.49v-1.238c0-1.797-1.412-3.253-3.158-3.263V17h-.016c-1.746.01-3.158 1.467-3.158 3.264v1.238h-.49c-.739 0-1.339.743-1.344 1.665v6.155c0 .926.601 1.678 1.343 1.678h7.314c.742 0 1.343-.752 1.343-1.678v-6.155c-.005-.922-.605-1.665-1.343-1.665z"
    transform="translate(-193.000000, -483.000000) translate(170.000000, 150.000000) translate(0.000000, 316.000000)"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LockIcon",
});
</script>
